// removed by extract-text-webpack-plugin
module.exports = {"CurrentTeamMembers":"CurrentTeamMembers---2i2W9"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/playbook/components/ExtensionInviteModal/CurrentTeamMembers/style.styl
// module id = rVLa
// module chunks = 89